export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

// Custom currency formatter function with default fraction digits
const createCurrencyFormatter = (fractionDigits = 2, currency = "USD") => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export const customCurrencyFormatter = (value: number, fractionDigits = 2, currency = "USD", keepCurrency = true) => {
  const formatFunction = keepCurrency
    ? createCurrencyFormatter(fractionDigits, currency)
    : createCurrencyFormatter(fractionDigits);
  return formatFunction.format(value);
};

export const getCurrencySign = (currency: string): string => {
  const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency });
  const symbol = formatter.formatToParts(0).find((part) => part.type === "currency")?.value;
  return symbol || currency; // Return the symbol or the currency code if not found
};
